module.exports = __webpack_public_path__ + "static/media/header_webinar.1f6a0b96.png";